import appGlobalScript from 'C:/Users/joshua.anderson/repos/United Federal Credit Union - UFCU/Xperience/wwwroot/ui/src/global/app.ts';
export const globalScripts = appGlobalScript;
